import type { FetchClient, RequestOptions } from '../../../lib/http/http.types';
import { mapLabeledCode } from '../../../lib/labeledCode';
import { normalizeLocale } from '../../../lib/locale';
import type { ContractListItem } from '../contractTypes';
import EmployeeEndpoints from '../../employees/api/employeeEndpoints';

const str = (v: unknown): string | undefined => {
  const s = v != null ? String(v).trim() : '';
  return s !== '' ? s : undefined;
};

function mapContractListItem(raw: Record<string, unknown>): ContractListItem {
  return {
    hc_uuid_key:           str(raw.hc_uuid_key) ?? '',
    is_current:             mapLabeledCode(raw.contratencours),
    contract_creation_type: mapLabeledCode(raw.typecreation),
    contract_type:          mapLabeledCode(raw.typecontrat),
    contract_start_date:    str(raw.datedeb),
    contract_end_date:      str(raw.datefin),
    job_function:           mapLabeledCode(raw.fonction),
    initial_start_date:    str(raw.initialstartdate),
    origin_field_contrat:  str(raw.origin_field_contrat),
  };
}

export function ContractListApiFactory(client: FetchClient, lang: string) {
  const headers = { 'Accept-Language': normalizeLocale(lang) };

  return {
    /**
     * Fetches the full contract history for a given employee.
     * GET /employees/:id/contracts  →  { data: ContractListItem[], meta: {...} }
     */
    getAllByEmployeeId: async (
      employeeId: string,
      opts?: RequestOptions,
    ): Promise<ContractListItem[]> => {
      const response = await client.get<{ data: Record<string, unknown>[] }>(
        EmployeeEndpoints.CONTRACTS_LIST(employeeId),
        { ...opts, headers: { ...opts?.headers, ...headers } },
      );
      if (!response || !Array.isArray(response.data)) return [];
      return response.data.map(mapContractListItem);
    },
  };
}
